"use client";
import React, { useState } from 'react'
import LoginLayout from '../login/_components/LoginLayout'
import ForgotPassword from './_components/ForgotPassword'
import VerifyOTP from '@/app/_components/VerifyOTP'
import ResetPassword from './_components/ResetPassword'
import ResetSuccessful from './_components/ResetSuccessful';

const page = () => {
  const [step, setStep] = useState<1 | 2 | 3 | 4>(1);
  const [phone, setPhone] = useState<string>("");

  return (
     <LoginLayout>
      {step === 1 && (
        <ForgotPassword onNext={(p) => { setPhone(p); setStep(2); }} />
      )}
      {step === 2 && (
        <VerifyOTP
          phoneNumber={phone}
          onNext={() => {
            setStep(3);
          }}
        />
      )}
      {step === 3 && (
        <ResetPassword onNext={()=>{setStep(4)}}/>
      )}
      {step === 4 && (
        <ResetSuccessful />
      )}
    </LoginLayout>
  )
}

export default page